import React, { useEffect } from "react"

/**
 * Sets up the App Insights analytics, docs: https://github.com/Microsoft/ApplicationInsights-JS
 * Mutates window to add window.appInsights
 */
export const AppInsights = () => {
  useEffect(() => {
    var sdkInstance = "appInsightsSDK";
    window[sdkInstance] = "appInsights";
    const config = {
      instrumentationKey: "78a8fb52-a225-4c66-ac08-92fad1c1ade1",
      // loggingLevelConsole: 1
    }

    // @ts-ignore
    var aiName = window[sdkInstance], aisdk = window[aiName] || function (e) { function n(e) { t[e] = function () { var n = arguments; t.queue.push(function () { t[e].apply(t, n) }) } } var t = { config: e }; t.initialize = !0; var i = document, a = window; setTimeout(function () { var n = i.createElement("script"); n.async = true; n.src = e.url || "https://az416426.vo.msecnd.net/scripts/b/ai.2.min.js", i.getElementsByTagName("script")[0].parentNode.appendChild(n) }); try { t.cookie = i.cookie } catch (e) { } t.queue = [], t.version = 2; for (var r = ["Event", "PageView", "Exception", "Trace", "DependencyData", "Metric", "PageViewPerformance"]; r.length;)n("track" + r.pop()); n("startTrackPage"), n("stopTrackPage"); var s = "Track" + r[0]; if (n("start" + s), n("stop" + s), n("setAuthenticatedUserContext"), n("clearAuthenticatedUserContext"), n("flush"), !(!0 === e.disableExceptionTracking || e.extensionConfig && e.extensionConfig.ApplicationInsightsAnalytics && !0 === e.extensionConfig.ApplicationInsightsAnalytics.disableExceptionTracking)) { n("_" + (r = "onerror")); var o = a[r]; a[r] = function (e, n, i, a, s) { var c = o && o(e, n, i, a, s); return !0 !== c && t["_" + r]({ message: e, url: n, lineNumber: i, columnNumber: a, error: s }), c }, e.autoExceptionInstrumented = !0 } return t }(config);
    window[aiName] = aisdk

    // @ts-ignore
    if (aisdk.queue && 0 === aisdk.queue.length) {
      const locationWithoutPlaygroundCode = document.location.href.split("#code")[0].split("#src")[0]
      const referrerWithoutPlaygroundCode = document.referrer && document.referrer.split("#code")[0].split("#src")[0]
      // @ts-ignore
      aisdk.trackPageView({ uri: locationWithoutPlaygroundCode, refUri: referrerWithoutPlaygroundCode });
    }
  })

  return (
    <>
      <div />
    </>
  )
}
